import { customContactUsForm } from "@bevco/Services/CommonService";
import { setGA4Event } from "@bevco/Store/Handlers/Utilities/CustomTracking";
import { clearInitialSiteLoadQuery, getInitialSiteLoadQuery } from "@bevco/Utilities/initialSiteLoadQuery";
import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

type SubmitContactFormParameter = {
    emailRecipients: string;
    leadSource: string;
    onError?: (error: string) => void;
} & HasOnSuccess<any>;

type HandlerType = ApiHandler<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const capitalize = (word: string) => word[0].toUpperCase() + word.slice(1);

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;

    const apiParameter: any = {};
    for (const key in state.fieldValues) {
        const value = state.fieldValues[key];
        if (value) {
            apiParameter[capitalize(key)] = value;
        }
    }

    if (props.parameter.leadSource) {
        apiParameter["LeadSource"] = props.parameter.leadSource;
    }

    const initialSiteLoad = getInitialSiteLoadQuery();
    if (initialSiteLoad?.queryParams) {
        for (const [key, raw] of Object.entries(initialSiteLoad.queryParams)) {
            if (raw === "" || (Array.isArray(raw) && raw.length === 0)) {
                continue;
            }
            // Each landing query name becomes its own apiParameter key; arrays become comma-separated
            apiParameter[key] = Array.isArray(raw) ? raw.join(",") : raw;
        }
    }

    props.apiParameter = { ...apiParameter };
};

export const SendDataToApi: HandlerType = async props => {
    const state = props.getState();
    const isAuthenticated = state.context.session.isAuthenticated && !state.context.session.isGuest;
    const billTo = getBillToState(state, state.context?.session?.billToId).value;
    let sapAccountNumber = "";
    if (isAuthenticated) {
        sapAccountNumber = billTo ? billTo.customerNumber.replace(/^0+/, "") : "__IS_LOADING__";
    }
    const formID = "contactForm";
    const accountNumber = sapAccountNumber;
    const formType = props.parameter.leadSource ?? "Contact Us";
    setGA4Event([], "formSubmissionSuccess", { formType, formID, accountNumber });

    try {
        const result = await customContactUsForm(props.parameter.emailRecipients, props.apiParameter);
        props.apiResult = result as any;

        clearInitialSiteLoadQuery();
    } catch (error) {
        props.parameter.onError?.(error);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
